import React from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { retrieveConfig } from '../../config/config'
import PaymentModel from '../payment-model'
import SessionTimeoutScreen from '../session-timeout-screen'
import messageService from '../../utils/message-service'
import ModalFooter from '../payment-model/modal-footer'
const API_BASE_URL = window.env.REACT_APP_DEMO_BACKEND_URL
import { paymentSessionRemover } from '../../utils/payment-session-remover'

function withParams(Component) {
    // eslint-disable-next-line react/display-name
    return props => <Component {...props} params={useParams()} />
}
class HostedPage extends React.Component {
    data = {}

    constructor(props) {
        super(props)
        this.state = {
            showInvalidSession: false,
            isPopupWindow: false,
            params: {},
            isSecureLink: false,
            showPaymentScreen: true,
            poweredByimages: [],
            showInvalidLink: false,
            showNoLinkError: false,
            invalidLinkMessage: {
                title: '',
                body: '',
            },
            formErrors: {
                code: false,
            },
            backgroundColor: 'white',
            background: '',
            poweredByText: '',
            isSubmitting: false, // Add a flag to track form submission
        }

        this.myRef = React.createRef()
    }

    // Track the last form submission timestamp
    lastSubmitTimestamp = 0
    // Minimum time between submissions in milliseconds
    minSubmitInterval = 2000

    // Create a method to handle form submission
    handleFormSubmit(data) {
        const now = Date.now()
        // Prevent submissions too quickly
        if (now - this.lastSubmitTimestamp < this.minSubmitInterval) {
            return
        }
        this.lastSubmitTimestamp = now

        // Prevent multiple submissions
        if (this.state.isSubmitting) {
            return
        }

        // Set the isSubmitting flag to true
        this.setState({ isSubmitting: true }, () => {
            // Call the toggle method on the PaymentModel component
            if (this.myRef.current) {
                this.myRef.current.toggle(data)

                // Reset the isSubmitting flag after a longer delay
                setTimeout(() => {
                    this.setState({ isSubmitting: false })
                }, 1500) // Increased timeout to ensure proper cleanup
            } else {
                // Reset the isSubmitting flag if the ref is not available
                this.setState({ isSubmitting: false })
            }
        })
    }

    async componentDidMount() {
        try {
            const selectedConfig = await retrieveConfig()

            if (!selectedConfig.title) {
                this.setState({
                    showInvalidLink: true,
                    invalidLinkMessage: {
                        title: 'Merchant Not Found',
                        body: selectedConfig?.message || selectedConfig?.error?.message || 'No merchant found for this domain.',
                    },
                })
                return
            }

            const title = selectedConfig.title

            const cdnHost = window.env.REACT_APP_CDN_HOST
            const urlRoot = cdnHost + '/app'

            const logo = selectedConfig.logo.url.replace('%CDN_HOST%', urlRoot)

            const supportEmail = selectedConfig?.supportEmail ?? ''
            const mailto = 'mailto:'.supportEmail

            const { data, id } = this.props.params

            this.setState({
                selectedConfig,
                title,
                logo,
                supportEmail,
                mailto,
                backgroundColor: selectedConfig.backgroundColor,
                background: selectedConfig.background,
                poweredByImages: this.getPoweredByIcons(selectedConfig),
            })

            if (!data) {
                this.setState({ isSecureLink: false })
                if (!selectedConfig.allowNoSecureLinks || !selectedConfig.enableStaticLinks) {
                    this.setState({
                        showInvalidLink: true,
                        invalidLinkMessage: {
                            title: 'Direct Access prohibited',
                            body: 'You need to navigate using a link provided by the merchant. Please contact your merchant for a link or QR code.',
                        },
                    })
                }
            }

            this.setState({ isSecureLink: true })

            const sessionId = id

            sessionStorage.setItem('paymentSessionId', sessionId)

            axios
                .post(API_BASE_URL + '/payment/session/' + sessionId)
                .then(data => {
                    if (!data) {
                        this.setState({
                            showInvalidLink: true,
                            invalidLinkMessage: {
                                title: 'Malformed URL',
                                body: 'The link you entered does not look like a valid link. If someone gave you this link, you may need to ask them to check that it is correct.',
                            },
                        })
                        return
                    }

                    window.setTimeout(() => {
                        this.handleFormSubmit({
                            orderId: data.data.orderId,
                            amount: data.data.amount,
                            currencyCode: data.data.currencyCode,
                            merchantId: data.data.serviceId,
                            configId: data.data.configId,
                            autoClose: data.data.autoClose,
                        })
                    }, 1000)

                    // const qs = data.data.decryptedData

                    // if (!qs) {
                    //     return
                    // }

                    // const formParams = LinkParser(qs)

                    // this.setState({ params: formParams })
                })
                .catch(error => {
                    console.error('Unable to decode link', error)

                    // Send session expired message using the message service
                    messageService.sendSessionExpired('Your payment link has expired.', {
                        error: error.message,
                        url: window.location.href,
                    })

                    // Check if this is a popup window for state management
                    if (window.opener && !window.opener.closed) {
                        this.setState({
                            isPopupWindow: true,
                        })
                    }

                    this.setState({
                        showInvalidSession: true,
                        invalidLinkMessage: {
                            title: 'Payment Link Expired',
                            body: 'Your payment link has expired. Please contact your merchant for a new payment link.',
                        },
                    })
                })
        } catch (error) {
            console.error('Error in componentDidMount:', error)
            this.setState({
                showInvalidLink: true,
                invalidLinkMessage: {
                    title: 'Merchant not found',
                    body: error?.response?.data?.message || 'No merchant found for provided merchantId',
                },
            })
        }
    }

    showModel() {
        this.setState({
            showPaymentScreen: true,
        })
    }

    getPoweredByIcons(selectedConfig) {
        const cdnHost = window.env.REACT_APP_CDN_HOST
        const urlRoot = cdnHost + '/app'

        if (selectedConfig?.poweredByImages) {
            return selectedConfig.poweredByImages.map(element => {
                return {
                    key: element.key,
                    url: element.url.replace('%CDN_HOST%', urlRoot),
                }
            })
        }

        return []
    }

    // Handle closing the timeout screen (window close)
    handleTimeoutScreenClose() {
        // Send final message using the message service
        messageService.sendWindowClosing('Your payment link has expired - window closing', {
            url: window.location.href,
            sessionExpired: true,
        })

        // Close the window or redirect
        if (window.opener) {
            // If opened as popup, close the window
            window.close()
        }
    }

    handlePaymentCompletion = () => {
        paymentSessionRemover()
    }

    render() {
        const merchantConfig = this.state.selectedConfig

        // Check if merchant has custom timeout configuration
        const timeoutConfig = merchantConfig?.sessionTimeout || {}

        if (!this.state.selectedConfig) {
            return <div></div>
        }

        // const poweredByText = this.state.selectedConfig?.poweredByText ?? 'Powered by'
        // const primaryColor = this.state.selectedConfig?.colorTheme?.primaryColor ?? '#334155'
        // const secondaryColor = this.state.selectedConfig?.colorTheme?.secondaryColor ?? '#4a90e2'
        //         const textColor = this.state.selectedConfig?.colorTheme?.text ?? this.state.selectedConfig.textColor
        // const poweredByImageKeys = this.state.selectedConfig.poweredBy
        // const poweredByImages = this.state.poweredByImages

        return (
            <>
                <div>
                    <Helmet>
                        <title>{this.state.selectedConfig?.title}</title>
                        {this.state.selectedConfig?.favIcons?.map((icon, index) => (
                            <link key={index} rel="icon" href={icon.url} sizes={icon.size} />
                        ))}
                    </Helmet>

                    {!this.state?.selectedConfig?.maintenance?.isActive && (
                        <PaymentModel
                            showModel={true}
                            ref={this.myRef}
                            isSdkPage={true}
                            onCompleted={this.handlePaymentCompletion}
                        />
                    )}

                    <SessionTimeoutScreen
                        isVisible={this.state?.showInvalidSession}
                        onClose={this.handleTimeoutScreenClose}
                        scenario="paymentLinkExpired"
                        config={{
                            ...timeoutConfig.modal,
                            ...timeoutConfig.paymentLinkExpiredScreen,
                            title: timeoutConfig.paymentLinkExpiredScreen?.title || 'Payment Link Expired',
                            message:
                                timeoutConfig.paymentLinkExpiredScreen?.message ||
                                'Your session has expired, please go back to your merchant and regenerate a payment link.',
                            countdownMessage:
                                timeoutConfig.paymentLinkExpiredScreen?.countdownMessage || 'Closing in {countdown} seconds...',
                            autoCloseDelay: timeoutConfig.paymentLinkExpiredScreen?.autoCloseDelay || 5000,
                        }}
                    />

                    {this.state?.selectedConfig?.maintenance?.isActive && (
                        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
                            <strong className="font-bold">Maintenance Alert!</strong>
                            <span className="block sm:inline">{this.state.selectedConfig.maintenance.message}</span>
                        </div>
                    )}
                </div>
                <ModalFooter config={this.state.selectedConfig} />
            </>
        )
    }
}

export default withParams(HostedPage)
